import merge from 'lodash.merge';

import sharedScreen from '#frontend/singleDataLayer/shared/screen.js';

/**
 * Error page object
 * @param {object} cart cart object
 * @param {object} error error
 * @returns {object} merged sdl object
 */
export default (cart, error = {}) => {
	const screenObject = {
		screen: {
			type: 'error',
			section: cart.error ? cart.error.app.status : error.code,
			name: 'Error'
		}
	};

	return merge(screenObject, sharedScreen(cart));
};
